import * as React from 'react';
import { TabPanel, Tabs } from 'react-tabs';

import { PageTitle } from '../pages/pageTitle';

import { EventsTableClippingColumns } from './eventTableForLiveAndHybrid';
import { ActiveEventsTableClippingContainer } from './eventTableActiveClippingContainer';
// import { ArchivedEventsTableContainer } from './eventsTableArchivedContainer';

const ActiveEventsTableColumns = [
  EventsTableClippingColumns.ClientName,
  EventsTableClippingColumns.EventName,
  EventsTableClippingColumns.EventType,
  EventsTableClippingColumns.EventStart,
  EventsTableClippingColumns.EventReadyEstimate,
  EventsTableClippingColumns.Assignee,
  EventsTableClippingColumns.Status,
  EventsTableClippingColumns.TotalParticipants,
  EventsTableClippingColumns.ParticipantsWithClipsGenerated,
  EventsTableClippingColumns.ClipGenerationErrors,
];

// eslint-disable-next-line react/prefer-stateless-function
export class EventsPageLiveAndHybrid extends React.Component {
  public render() {
    return (
      <>
        <PageTitle displayTitle="Clipping Queue" />
        <Tabs>
          <TabPanel>
            <ActiveEventsTableClippingContainer columns={ActiveEventsTableColumns} />
          </TabPanel>
        </Tabs>
      </>
    );
  }
}
